/**
* @summary - Component that Provides PPM Planner functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  IconButton,
  Typography
} from "@mui/material";
import Tab from '@mui/material/Tab';
import React, { useState } from 'react';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import PpmSchedule from './ppmSchedule';
import PpmShowSchedule from './ppmShowSchedule';
import {getFacilityId,getcompanyId} from '../../utility/tokenUtility'
import PageTitle from "../commoncomponents/PageTitle";
function PpmPlannerMain() {
  const [value, setValue] = useState('1');
  const[workgroup,setWorkGroup]=useState();
  const[year,setYear]=useState();
  const [serviceType,setServiceType] = useState();
  const [allRows,setAllRows] = useState([]);
  const [approvedBy, setApprovedBy] = useState('');
  const [proposedBy, setProposedBy] = useState('');

  const facilityId= getFacilityId();
  const companyId=getcompanyId();
    const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  const handleHomeClick = () => {
    navigate('/dashboard'); // Adjust the path as needed
  };

  return (
    <>
      <BreadcrumbBar>
        <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>
        <PageTitle title={"PPM planner"} />
        </Box>       
      </BreadcrumbBar>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="asset-record" variant="scrollable" scrollButtons="auto">
            <Tab label="Planned Preventive Maintenance Schedule" value="1" />
            <Tab label="Show the Schedule" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <PpmSchedule companyId ={companyId} 
            facilityId={facilityId}
            handleYear={(item)=>setYear(item)}
            handleWorkGroup={(item)=>setWorkGroup(item)} 
            handleServiceType={(item)=>setServiceType(item)} 
            handleAllRows={(item)=>setAllRows(item)}
            selectedWorkgroup={workgroup} 
            selectedYear={year} 
            selectedServiceType={serviceType} 
            allGridRows={allRows}
            handleApprovedBy={(item)=>setApprovedBy(item)} 
            handleProposedBy={(item)=>setProposedBy(item)} 
            selectedApprovedBy={approvedBy} 
            selectedProposedBy={proposedBy}/>
        </TabPanel>
        <TabPanel value="2">
          <PpmShowSchedule 
          allRows={allRows} 
          companyId ={companyId} 
          facilityId={facilityId} 
          workgroup={workgroup} 
          year={year} 
          serviceType={serviceType} 
          approvedBy={approvedBy}
          proposedBy={proposedBy}          
          />
        </TabPanel>
      </TabContext>
    </>
  );
}

export default PpmPlannerMain;
